module.exports = __webpack_public_path__ + "static/media/athlete-small.f85903d4.png";